import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=1ef0ff1e&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&id=1ef0ff1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef0ff1e",
  null
  
)

export default component.exports